import React, { useState } from 'react'

import { OtpVerify } from 'pages/SignIn/OtpVerify'

import { linkAccounts } from 'store/auth/actions'
import { useDispatch, useSelector } from 'store/hooks'

import { Stack, Typography, Button } from '@mui/material'

interface LinkAccountsProps {
  handleClose: () => void
  inDrawer?: boolean
}

export const LinkAccounts = ({ handleClose, inDrawer = false }: LinkAccountsProps) => {
  const dispatch = useDispatch()

  const [openOtpVerify, setOpenOtpVerify] = useState<boolean>(false)

  const { email, shopify_user } = useSelector(({ auth }) => ({
    shopify_user: auth.shopify_user,
    email: auth.profile?.email,
  }))

  const linkAccountsHandle = () => {
    setOpenOtpVerify(true)
    dispatch(
      linkAccounts({ email: shopify_user }, ({ success }) => {
        success && setOpenOtpVerify(true)
      })
    )
  }

  return (
    <>
      {openOtpVerify ? (
        <Stack
          sx={{
            textAlign: 'center',
          }}
        >
          <OtpVerify handleClose={handleClose} email={email as string} inDrawer linkAccounts />
          <Stack sx={{ width: '100%', marginTop: '24px' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              fullWidth
            >
              Cancel
            </Button>
          </Stack>
        </Stack>
      ) : (
        <Stack>
          <Typography p="4px 0 56px" sx={{ textAlign: 'center', lineHeight: '20px' }}>
            Do you want to link your Shopify <br />
            and VERA accounts?
          </Typography>
          <Stack>
            <Button
              sx={theme => ({
                marginBottom: '12px',
              })}
              fullWidth
              onClick={linkAccountsHandle}
            >
              Link Accounts
            </Button>
            <Button 
              onClick={handleClose}
              variant="outlined"
              fullWidth
            >
              No, Thank You
            </Button>
          </Stack>
        </Stack>
      )}
    </>
  )
}
